module.exports = __webpack_public_path__ + "static/media/lineto-akkurat-pro-regular-0f24c307957d9a6513f3a80c452857ad.0f24c307.woff";